import { connect } from 'react-redux';
import { fetchInventoryAuditLogsForItem } from '../../../redux/Inventory/sagas/components/view-item/routines';
import {
  getIsFetchingItemAuditLogs,
  getIsFetchedItemAuditLogs
} from '../../../redux/Inventory/selectors/components/view-item';
import {
  getPaginationLoadedPages as getItemAuditLogsPaginationLoadedPages,
  getPaginationWithoutPages as getItemAuditLogsPaginationWithoutPages,
  getPaginationQueryOptions as getItemAuditLogsPaginationQueryOptions,
  getCurrentPageItems as getItemAuditLogsCurrentPageItems
} from '../../../redux/Inventory/selectors/components/view-item/audit-log-pagination';
import { updateAuditLogsSearchQuery } from '../../../redux/Inventory/actions/components/audit-log-search';
import {
  clearInventoryItemAuditLogs,
  inventoryItemAuditLogsOnChangePage
} from '../../../redux/Inventory/actions/components/view-item';
import { getAuditLogSearchQuery } from '../../../redux/Inventory/selectors/components/audit-log-search';
import InventoryAuditLogList from '../../../components/inventory/AuditLogList';

function mapStateToProps(state, { item }) {
  const paginationQuery = getItemAuditLogsPaginationQueryOptions(state);
  const searchQuery = getAuditLogSearchQuery(state);
  return {
    showItemColumn: false,
    query: { ...paginationQuery, ...searchQuery },
    auditLogs: getItemAuditLogsCurrentPageItems(state),
    loadedPages: getItemAuditLogsPaginationLoadedPages(state),
    pagination: getItemAuditLogsPaginationWithoutPages(state),
    isFetching: getIsFetchingItemAuditLogs(state),
    isFetched: getIsFetchedItemAuditLogs(state, item.id)
  };
}

function mapDispatchToProps(dispatch, { item }) {
  const { id: itemId } = item;
  return {
    onInit: () => {
      dispatch(fetchInventoryAuditLogsForItem({ itemId }));
      dispatch(updateAuditLogsSearchQuery({ itemId }));
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded)
        dispatch(fetchInventoryAuditLogsForItem({ ...query, itemId }));
      else dispatch(inventoryItemAuditLogsOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearInventoryItemAuditLogs());
      dispatch(fetchInventoryAuditLogsForItem({ ...query, itemId }));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryAuditLogList);
